// extracted by mini-css-extract-plugin
export default {"nursingPlacement":"NursingPlacementPage_nursingPlacement__+32L6","item":"NursingPlacementPage_item__eaKyz"};